import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@/components/common/Loader';
import MailchimpTiers from '@/constants/integrations/MailchimpTiers';
import ConstituentFilterPropType from '@/lib/types/ConstituentFilterPropType';
import { LazyDialog } from '@/modules/Dialogs';
import lazyWithRetry from '@/utils/lazyWithRetry';

const ConstituentExportDestinationDialogContent = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "constituent-export-destination-dialog" */
    './ConstituentExportDestinationDialogContent'
  ),
);

export default function ConstituentExportDestinationDialog({
  destination,
  filters,
  mailchimpPricingTier,
  setDestination,
  totalConstituents,
  ...dialogProps
}) {
  const fallback = <Loader isCentered />;

  return (
    <React.Suspense fallback={fallback}>
      <LazyDialog
        className="min-w-full"
        fullWidth
        data-testid="constituent-export-destination-dialog"
        scroll="paper"
        {...dialogProps}
      >
        <ConstituentExportDestinationDialogContent
          destination={destination}
          filters={filters}
          onClose={dialogProps.onClose}
          mailchimpPricingTier={mailchimpPricingTier}
          setDestination={setDestination}
          totalConstituents={totalConstituents}
        />
      </LazyDialog>
    </React.Suspense>
  );
}

ConstituentExportDestinationDialog.propTypes = {
  destination: PropTypes.string,
  filters: ConstituentFilterPropType,
  mailchimpPricingTier: PropTypes.string,
  setDestination: PropTypes.func,
  totalConstituents: PropTypes.number,
};

ConstituentExportDestinationDialog.defaultProps = {
  destination: '',
  filters: {},
  mailchimpPricingTier: MailchimpTiers.FREE,
  setDestination: () => {},
  totalConstituents: 0,
};
